"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDatasheetStateSchema = exports.DatasheetStateReason = exports.DatasheetState = void 0;
const z = require("zod");
var DatasheetState;
(function (DatasheetState) {
    DatasheetState["Found"] = "found";
    DatasheetState["Searching"] = "searching";
    DatasheetState["NotFound"] = "not_found";
    DatasheetState["NotApplicable"] = "not_applicable";
})(DatasheetState || (exports.DatasheetState = DatasheetState = {}));
var DatasheetStateReason;
(function (DatasheetStateReason) {
    DatasheetStateReason["AllSourcesFailed"] = "all_sources_failed";
    DatasheetStateReason["NoSources"] = "no_sources";
    DatasheetStateReason["AgentNotFound"] = "agent_not_found";
    DatasheetStateReason["AllCandidatesRejected"] = "all_candidates_rejected";
    DatasheetStateReason["Mechanical"] = "mechanical";
    DatasheetStateReason["TestPoint"] = "test_point";
})(DatasheetStateReason || (exports.DatasheetStateReason = DatasheetStateReason = {}));
exports.PackageDatasheetStateSchema = z.object({
    packageId: z.string(),
    fileId: z.string().nullable(),
    state: z.nativeEnum(DatasheetState).nullable(),
    reason: z.nativeEnum(DatasheetStateReason).nullable(),
    lastAttemptAt: z.date().nullable(),
    nextAttemptAt: z.date().nullable(),
    searchAttempts: z.number().int().min(0),
});
//# sourceMappingURL=package-datasheet-state.js.map